import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { BounceInDownButton } from '../../animation/bounceIn';
import { useChangePassword } from './api/apiSecuritysettings';
import { CircularProgress } from '@mui/material';


const schema = yup.object().shape({
    currentPassword: yup.string()
        .max(30, 'Password must be at most 30 characters')
        .required('Password is Required'),
    newPassword: yup.string()
        .min(6, 'Password must be at least 6 characters')
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&#]{6,30}$/, 'Password must contain at least one uppercase letter, one lowercase letter, one number and one special character')
        .max(30, 'Password must be at most 30 characters')
        .required('Password is Required')
        .test(
            'not-same-as-current',
            'New password must be different from the current password.',
            function (value) {
                return value !== this.parent.currentPassword;
            }
        ),
    confirmNewPassword: yup.string()
        .oneOf([yup.ref('newPassword'), null], "Confirm Password doesn't match")
        .required('Confirm Password is Required'),
})

function ChangePassword() {

    const changePasswordmutation = useChangePassword();
    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
        }
    });

    const onSubmit = async (data) => {
        let res = await changePasswordmutation.mutateAsync(data)
        if (res.status) reset()
    }

    const [inputType, setInputType] = useState({
        current: true,
        NewPw: true,
        ConfirmPw: true,
    });

    const handleInputChange = (paramName, value) => {
        setInputType((prevParams) => (
            {
                ...prevParams,
                [paramName]: value,
            }));
    };



    return (
        
                <BounceInDownButton>
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-xl-6 col-xxl-5">
                            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                                <div className='mb-3'>
                                    <label className="form-label" htmlFor="crntpw">Current Password</label>
                                    <div className="input-group">
                                        <Controller name='currentPassword' control={control} render={({ field }) => (
                                            <input
                                                {...field}
                                                type={inputType.current ? "password" : "text"}
                                                className="form-control"
                                                placeholder='Enter your current password'
                                                autoComplete='off'
                                                autoFocus
                                            />
                                        )} />

                                        <button type="button" onClick={() => handleInputChange('current', !inputType.current)} className={`btn p-0 input-group-icon border-0 shwPwd ${inputType.current ? "" : "show-eye"}`.trim()} >
                                            <img src={require('../../assets/images/icons/eye-slash.svg').default} className='img-fluid eye-hide' alt="eye-slash" />
                                            <img src={require('../../assets/images/icons/eye.svg').default} className='img-fluid eye-show' alt="eye" />
                                        </button>
                                    </div>
                                    {errors.currentPassword && <p className="errMsg">* {errors.currentPassword.message}</p>}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label" htmlFor="crntpw">New Password</label>
                                    <div className="input-group">
                                        <Controller name='newPassword' control={control} render={({ field }) => (
                                            <input
                                                {...field}
                                                type={inputType.NewPw ? "password" : "text"}
                                                className="form-control"
                                                placeholder='Enter your new password'
                                                autoComplete='off'
                                            />
                                        )} />

                                        <button type="button" onClick={() => handleInputChange('NewPw', !inputType.NewPw)} className={`btn p-0 input-group-icon border-0 shwPwd ${inputType.NewPw ? "" : "show-eye"}`.trim()} >
                                            <img src={require('../../assets/images/icons/eye-slash.svg').default} className='img-fluid eye-hide' alt="eye-slash" />
                                            <img src={require('../../assets/images/icons/eye.svg').default} className='img-fluid eye-show' alt="eye" />
                                        </button>
                                    </div>
                                    {errors.newPassword && <p className="errMsg">* {errors.newPassword.message}</p>}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label" htmlFor="crntpw">Confirm Password</label>
                                    <div className="input-group">
                                        <Controller name='confirmNewPassword' control={control} render={({ field }) => (
                                            <input
                                                {...field}
                                                type={inputType.ConfirmPw ? "password" : "text"}
                                                className="form-control"
                                                id="inputconfirmpw" placeholder="Enter your confirm password"
                                                autoComplete='off'
                                            />
                                        )} />

                                        <button type="button" onClick={() => handleInputChange('ConfirmPw', !inputType.ConfirmPw)} className={`btn p-0 input-group-icon border-0 shwPwd ${inputType.ConfirmPw ? "" : "show-eye"}`.trim()} >
                                            <img src={require('../../assets/images/icons/eye-slash.svg').default} className='img-fluid eye-hide' alt="eye-slash" />
                                            <img src={require('../../assets/images/icons/eye.svg').default} className='img-fluid eye-show' alt="eye" />
                                        </button>
                                    </div>
                                    {errors.confirmNewPassword && <p className="errMsg">* {errors.confirmNewPassword.message}</p>}
                                </div>
                                <div className="d-grid crPgbtn pt-2">
                                    <button className="btn btn-primary" disabled={changePasswordmutation.isLoading}>
                                        {changePasswordmutation.isLoading ?
                                            <CircularProgress style={{ color: "#fff" }} size={20} /> :
                                            "Change Password"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </BounceInDownButton>
 

        
    )
}

export default ChangePassword